import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import ContentService from 'services/loader-handler-services/content-service';
import LocaleService from 'services/loader-handler-services/locale-service';
import SurveyService from 'services/data-handler-services/survey-service';
import SyncService from 'services/data-handler-services/sync-service';
import AssessmentService from 'services/data-handler-services/assessment-service';
import EvaluationService from 'services/data-handler-services/evaluation-service';
import LearnerProfileService from 'services/course-handler-services/learner-profile-service';
import EF from 'ef/ef';

class ServicesInitializer {
  static start(config) {
    CourseSettingsService.initialize(config.settings).then(function () {
      Promise.all([ContentService.initialize(), LocaleService.initialize(config.i18n)])
        .then(function () {
          const groupsJson = ContentService.groups;
          const modulesJson = ContentService.modules;
          const modulesContentJson = ContentService.moduleContent;
          const enrollment = config.enrollment;

          EF.init(
            groupsJson,
            modulesJson,
            modulesContentJson,
            enrollment,
            {
              local: config.settings.local,
              apiOnly: true,
              autoNextActivity: true,
              loadActivityProgresses: config.settings.progressProvider !== 'content-service',
              evaluations: config.evaluations,
            },
            config.settings
          );
          SurveyService.initialize(config.surveys);
          AssessmentService.initialize(config.assessments);
          EvaluationService.initialize(config.evaluations);
          LearnerProfileService.initialize(config.learnerProfile);

          window.addEventListener(
            'message',
            async event => {
              if (event.data.event_type === 'reload-evaluation') {
                await EvaluationService.updateResponseSet(event.data.slug, event.data.response_set);
              }
            },
            false
          );
        })
        .catch(function (err) {
          console.log(`Content Loading Failed! Maybe you have an error in your JSON? ${err}`);
        });
    });

    if (config.settings.local) {
      SyncService.initialize(config.settings);
    }
  }
}

export default ServicesInitializer;
